import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import NorthlightLogo from './NorthlightLogo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Leistungen', target: 'services' },
    { name: 'Portfolio', target: 'portfolio' },
    { name: 'Zusammenarbeit', target: 'pricing' },
    { name: 'Erstgespräch', target: 'booking' },
  ];

  const scrollTo = (target) => {
    document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header
        data-testid="header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || isMobileMenuOpen ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/[0.06] py-3' : 'py-5'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between">
            <button onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMobileMenuOpen(false); }} className="flex items-center">
              <NorthlightLogo size="default" />
            </button>

            <nav className="hidden md:flex items-center gap-7">
              {navLinks.map((link) => (
                <button
                  key={link.name}
                  onClick={() => scrollTo(link.target)}
                  className="text-sm font-medium text-gray-400 hover:text-white transition-colors duration-200"
                >
                  {link.name}
                </button>
              ))}
            </nav>

            <div className="hidden md:block">
              <button
                data-testid="header-cta"
                onClick={() => scrollTo('booking')}
                className="px-6 py-2.5 bg-[#ff84e4] text-black font-medium text-sm rounded-full transition-colors duration-200 hover:bg-[#ffd1e7]"
              >
                Testprojekt anfragen
              </button>
            </div>

            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2 text-white relative z-50"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-[#0a0a0a]/98 backdrop-blur-lg md:hidden" onClick={() => setIsMobileMenuOpen(false)}>
          <nav className="flex flex-col items-center justify-center h-full gap-6" onClick={(e) => e.stopPropagation()}>
            {navLinks.map((link) => (
              <button
                key={link.name}
                onClick={() => scrollTo(link.target)}
                className="text-xl font-medium text-gray-300 hover:text-white transition-colors"
              >
                {link.name}
              </button>
            ))}
            <button
              onClick={() => scrollTo('contact')}
              className="mt-4 px-8 py-3 bg-[#ff84e4] text-black font-semibold text-base rounded-full transition-colors duration-200 hover:bg-[#ffd1e7]"
            >
              Testprojekt anfragen
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
